<div class="yf-row centered gap-12">
  <div class="yf-row centered gap-6 yf-text-center">
    <ion-icon src="assets/app-icons/unplug.svg" style="font-size: 22px">
    </ion-icon>
    <ion-text color="tertiary" class="fs-14 fw-600">{{ "APP.INSTALLATION.UNPLUG_CABLE_TO_END_SESSION" | translate }}</ion-text>
  </div>
</div>
